export default __webpack_public_path__ + "static/media/111年之蘆洲家醫海報.d4d86e28.jpg";